import { loginWithXS } from '@xinosolutions/auth-sdk';

/** Open the XS Auth registration popup with mode=signup. */
export function registerWithXsAuth({ clientId, authBaseUrl, ...rest } = {}) {
  return loginWithXS({
    clientId,
    ...(authBaseUrl ? { authBaseUrl } : {}),
    prompt: 'login',
    mode: 'signup',
    ...rest,
  });
}
